document.addEventListener("DOMContentLoaded", function () {


      const toggle = document.getElementById('lock-icon');
    const offLabel = document.getElementById('offLabel');
    const onLabel = document.getElementById('onLabel');
    let isOn = true;

    toggle.addEventListener('click', () => {
      isOn = !isOn;
      toggle.classList.toggle('is-active', isOn);
      onLabel.classList.toggle('is-active', isOn);
      offLabel.classList.toggle('is-active', !isOn);
    });

  
// let locked = true;

// const toggleButton = document.getElementById('lock-icon');
// const shackle = document.getElementById('shackle');

// toggleButton.addEventListener('click', function () {
//   locked = !locked;
//   const newPath = locked
//     ? "M20,28v-1a12,12 0 0 1 24,0"  // locked path
//     : "M20,28v-6a12,12 0 1 1 24,0"; // unlocked path
// document.getElementById('lock-icon').classList.toggle('is-active');

//   shackle.setAttribute('d', newPath);
// });

  
  if(document.querySelector(".additional_info")){
document.querySelector(".additional_info").addEventListener("change", function() {
    var div = document.querySelector(".hide_info");
  if(document.querySelector(".hide_info").classList.contains('hidden') == true ){
    div.classList.remove("hidden");
  }else{
    div.classList.add("hidden");
  }
  
});



  document.querySelector("#additional").addEventListener("change", function() {
    var div = document.querySelector(".hide_info");
    if(document.querySelector(".hide_info").classList.contains('hidden') == true){
    div.classList.remove("hidden");
  }else{
    div.classList.add("hidden");
  }
});
  
}
    var scrollTop = window.scrollY || document.documentElement.scrollTop; 
  var header = document.querySelector("header"); 
  if (scrollTop > 100 && !header.classList.contains('open')) {
    header.classList.add('open');
  } 
 
  else if (scrollTop <= 100) {
    header.classList.remove('open');
  }
})
window.addEventListener("scroll", function() { 
  var scrollTop = window.scrollY || document.documentElement.scrollTop; 
  var header = document.querySelector("header"); 
  if (scrollTop > 50 && !header.classList.contains('open')) {
    header.classList.add('open');
  } 
 
  else if (scrollTop <= 50) {
    header.classList.remove('open');
  }
});

const fileInput = document.getElementById("image");
const imagePreview = document.getElementById("imagePreview");
const uploadArea = document.getElementById("uploadArea");
var aspectRatio = "";

let tempFiles;

uploadArea.addEventListener("dragover", function (e) {
  e.preventDefault();
  tempFiles = e.dataTransfer.items;
  uploadArea.classList.add("drag-over");
});

uploadArea.addEventListener("dragleave", function (e) {
  uploadArea.classList.remove("drag-over");
});

uploadArea.addEventListener("drop", function (e) {
  e.preventDefault();
  uploadArea.classList.remove("drag-over");
  tempFiles = e.dataTransfer.items;
  if (tempFiles) {
    let files = [];
    for (let item of tempFiles) {
      if (item.kind === "file") {
        files.push(item.getAsFile());
      }
    }
    handleFiles(files);
  }
  tempFiles = null;
});

fileInput.addEventListener("change", function () {
  handleFiles(fileInput.files);
});
function getImageAspectRatio(imageWidth, imageHeight) {
  return imageWidth / imageHeight;
}
function handleFiles(files) {
  imagePreview.innerHTML = "";
  var image = document.getElementById("imagePreview");
  for (const file of files) {
    var reader = new FileReader();
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.ai|\.pdf|\.csv)$/i;
    var filePath = file.name;
    if (!allowedExtensions.exec(filePath)) {
      var erer = document.getElementById("info");
      erer.style.display = "block";
      erer.innerHTML =
        '<i class="fa fa-close"></i> Sorry, only accepted files are .jpg, .jpeg, .png, .ai, .pdf, .csv ';
      fileInput.value = "";
      return false;
    } else {
      reader.onload = function (e) {
        document.getElementById("info").style.display = "none";
        image.src = e.target.result;

        var img = new Image();
        img.src = e.target.result;
        const imgPreview = document.createElement("img");
        imgPreview.className = "imagepreview drop-zoon__loading-text";
        imgPreview.src =
          "https://cdn.shopify.com/s/files/1/0843/0282/3744/files/loading-gif.gif?v=1707301777";
        imagePreview.appendChild(imgPreview);
      
        var elementsImg = document.getElementsByClassName("image-area");
        elementsImg[0].style.display = "flex";
        elementsImg[0].style.flexDirection = "column";
        var elementsUpload =
          document.getElementsByClassName("upload-container");
        elementsUpload[0].style.display = "none";
        img.onload = function () {
          document.querySelector(".UploadedImage").classList.add("hidden");
          const htmlClose = document.createElement("div");
          htmlClose.className = "upload__img-close";
          htmlClose.textContent = "×";
          imagePreview.append(htmlClose);

          var widthInches = img.width / 300; // Assuming standard DPI is 96
          var heightInches = img.height / 300;

          var widthInchesrounded = Math.round(widthInches);
          var heightInchesrounded = Math.round(heightInches);
          aspectRatio = getImageAspectRatio(
            widthInchesrounded,
            heightInchesrounded
          );
          aspectRatio = aspectRatio.toFixed(2);
          console.log(widthInchesrounded);
          console.log(heightInchesrounded);
          if (widthInchesrounded > 15 || heightInchesrounded > 15) {
            if (widthInchesrounded > 15) {
              var newwidthInchesrounded = 15;
              var newheightInchesrounded =
                (newwidthInchesrounded * heightInches) / widthInches;
              console.log(newheightInchesrounded + "...........");
              widthInchesrounded = widthInches = 15;
              heightInches = heightInchesrounded = newheightInchesrounded;
            }
            if (heightInchesrounded > 15) {
              var newheightInchesrounded = 15;
              var newwidthInchesrounded =
                (newheightInchesrounded * widthInches) / heightInches;
              console.log(newwidthInchesrounded + "...........");
              heightInchesrounded = heightInches = 15;
              widthInches = widthInchesrounded = newwidthInchesrounded;
            }
          }
          var valueToCheck = widthInchesrounded + "*" + heightInchesrounded;
          // var selectValue = document.querySelector(
          //   '.custom-input-area input[name="option1"][value="' +
          //     valueToCheck +
          //     '"]'
          // );
           var selectValue = document.querySelector(
            '.custom-input-area label[value="' +
              valueToCheck +
              '"]'
          );
          console.log(selectValue);
          if (selectValue != null) {
            selectValue.click();
            selectValue.checked = true;
          } else {
            var inputMultiply =
              Math.round(widthInchesrounded) * Math.round(heightInchesrounded);
            var allValue = document.querySelectorAll(
              '.custom-input-area input[name="option1"]'
            );


            allValue.forEach(function (allValue) {
              var inputAllvalue = allValue.value;
              var parts = inputAllvalue.split("*");
              var valueMultiply =
                parseInt(parts[0], 10) * parseInt(parts[1], 10);
              if (inputMultiply == valueMultiply) {
                console.log("match");
                document
                  .querySelector(
                    '.custom-input-area input[name="option1"][value="' +
                      inputAllvalue +
                      '"]'
                  )
                  .click();
                document.querySelector(
                  '.custom-input-area input[name="option1"][value="' +
                    inputAllvalue +
                    '"]'
                ).checked = true;
              }
            });
          }

          document.querySelector(".Imgheight").value = heightInches.toFixed(2);
          document.querySelector(".ImgWidth").value = widthInches.toFixed(2);
        const lockIcon = document.getElementById('lock-icon');
        
        if (lockIcon.classList.contains('is-active')) {
          // Do something if it has the class
          console.log('Lock icon is active');
           document.querySelector("#imageSelectedWidth").value =
            widthInches.toFixed(2);
          document.querySelector("#imageSelectedHight").value =
            heightInches.toFixed(2);
        } else {
          // Do something else if it doesn't
          console.log('Lock icon is not active');
        }
         
          
          document.querySelector(".selectedImageSize .radio-label").innerHTML =
            "Detected size: " +
            widthInches.toFixed(2) +
            " x " +
            heightInches.toFixed(2);
          console.log("Width: " + widthInches.toFixed(2) + " inches");
          console.log("Height: " + heightInches.toFixed(2) + " inches");
        };
      };

      reader.readAsDataURL(file);
      uploadImagetoServer(file);
    }
  }
}

uploadArea.addEventListener("click", function () {
  fileInput.click();
});

function uploadImagetoServer(file) {
  var formData = new FormData(document.querySelector("#customImage"));
  if (file != -undefined) {
    formData.append("image", file);
  }

  fetch("https://designerts.online/priceonprint/index.php", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.text()) // Assuming the server response is text, change accordingly if JSON
    .then((responseText) => {
      var obj = JSON.parse(responseText);

      if (obj.type == "ai" || obj.type == "eps") {
        document.querySelector(".UploadedImage").classList.add("hidden");
        const htmlClose = document.createElement("div");
        htmlClose.className = "upload__img-close";
        htmlClose.textContent = "×";
        imagePreview.append(htmlClose);

        const imgPreview = document.querySelector(".imagepreview");
        var imdSrc =
          obj.type == "ai"
            ? "https://cdn.shopify.com/s/files/1/0843/0282/3744/files/Ai_29715.png?v=1707479409"
            : "https://cdn.shopify.com/s/files/1/0843/0282/3744/files/Mengatasi-File-EPS-Terlalu-Besar.png?v=1707479409";
        imgPreview.src = imdSrc;

        document.querySelector(".Imgheight").value = 0;
        document.querySelector(".ImgWidth").value = 0;
        document.querySelector("#imageSelectedWidth").value = 0;
        document.querySelector("#imageSelectedHight").value = 0;
        // document.querySelector('.custom-input-area input[name="option1"][value="15*10"]').click();
        // document.querySelector('.custom-input-area input[name="option1"][value="15*10"]').checked = true;
      } else {
        document.querySelector(".imagepreview").setAttribute("src", obj.data.file_link);

        if(document.querySelector(".imagepreview1")){
           document.querySelector(".imagepreview1").src = "https://cdn-icons-png.flaticon.com/512/9159/9159105.png";
        document.querySelector(".image-preview").style.display = "none";

        document.querySelector(".image-preview-close").style.display = "block";

        if(document.querySelector(".upload__img-close_csv")){
          document.querySelector(".upload__img-close_csv").remove();
        }
               const htmlClose = document.createElement("div");
          htmlClose.className = "upload__img-close_csv";
          htmlClose.textContent = "×";
         document.querySelector(".image-preview-close").append(htmlClose);

        }
      }

      document
        .querySelector(".imagepreview")
        .classList.remove("drop-zoon__loading-text");
      var link = document.querySelector(".UploadedImage");
      link.setAttribute("href", obj.data.file_link);
      document.querySelector(".Imageuploaded").value = obj.data.file_link;
      console.log(obj.data.file_link);

      document
        .querySelector(".product-info__quantity-selector")
        .classList.remove("hidden");
      document
        .querySelector(".product-info__buy-buttons")
        .classList.remove("hidden");
      document.querySelector(".custom-input-area").classList.remove("hidden");
      document.querySelector(".UploadedImage").classList.remove("hidden");

       document.querySelector('.size-selector .radio-label').click();

      const radioButtons = document.querySelectorAll('.variant-picker__option input[type="radio"]');
      radioButtons.forEach(radio => {  
        if (radio.checked) {
          radio.classList.add('active_radio');
        }
      });

    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// Function to increment or decrement input value by 0.5
function updateInputValue(button, isIncrement, event, type, is_button) {
  event.preventDefault();
  var input = button.parentElement.querySelector("input");
  var currentValue = parseFloat(input.value);

  if (isNaN(currentValue)) {
    currentValue = 0;
  }

  if (is_button == "button") {
    if (isIncrement) {
      if (currentValue < 15) {
        input.value = (currentValue + 0.1).toFixed(2);
      }
    } else {
      if (currentValue > 0) {
        input.value = (currentValue - 0.1).toFixed(2);
      }
    }
  }
  updateTextWithInputValue(type);
}

function updateTextWithInputValue(type) {
  console.log(aspectRatio + "aaaaaaaaaaaaaaaaa");
  console.log(type + "ttttttttttttt");
  const imgPreviewSrc = document
    .querySelector(".imagepreview")
    .getAttribute("src");

  console.log(imgPreviewSrc);
  if (
    imgPreviewSrc !==
      "https://cdn.shopify.com/s/files/1/0843/0282/3744/files/Mengatasi-File-EPS-Terlalu-Besar.png?v=1707479409" &&
    imgPreviewSrc !==
      "https://cdn.shopify.com/s/files/1/0843/0282/3744/files/Ai_29715.png?v=1707479409"
  ) {
    console.log("No EPS - AI File");
    const lockIcon = document.getElementById('lock-icon');
    if (type == "width") {
      var widthInches = document.querySelector("#imageSelectedWidth").value;
      console.log(widthInches + "widthInches");
      var newHeightinches = widthInches / aspectRatio;
      console.log(newHeightinches + "newWidthinches");
      if (newHeightinches < 15) {
        if (lockIcon.classList.contains('is-active')) {
          document.querySelector("#imageSelectedHight").value =
            newHeightinches.toFixed(2);
        }
      }
    } else {
      var heightInches = document.querySelector("#imageSelectedHight").value;
      console.log(heightInches);
      var newWidthinches = heightInches * aspectRatio;
      console.log(newWidthinches);
      if (newWidthinches < 15) {
        if (lockIcon.classList.contains('is-active')) {
          document.querySelector("#imageSelectedWidth").value =
            newWidthinches.toFixed(2);
        }
      }
    }
  }
  var widthInches = document.querySelector("#imageSelectedWidth").value;
  var heightInches = document.querySelector("#imageSelectedHight").value;
  document.querySelector(".Imgheight").value = heightInches;
  document.querySelector(".ImgWidth").value = widthInches;
  document.querySelector(".selectedImageSize .radio-label").innerHTML =
    "Detected size: " + widthInches + " x " + heightInches;

  var widthInchesrounded = Math.round(widthInches);
  var heightInchesrounded = Math.round(heightInches);
  var inputMultiply = widthInchesrounded * heightInchesrounded;

  console.log(widthInchesrounded);
  console.log(heightInchesrounded);
  var valueToCheck = widthInchesrounded + "*" + heightInchesrounded;
  // var selectValue = document.querySelector(
  //   '.custom-input-area input[name="option1"][value="' + valueToCheck + '"]'
  // );

  var selectValue = document.querySelector(
    '.custom-input-area label[value="' + valueToCheck + '"]'
  );

  console.log('selectValue---- ',selectValue);
  if (selectValue != null) {
    console.log('selectValue---- yessss',);
    // selectValue.dispatchEvent(new Event("change", { bubbles: true }));
    selectValue.click();
    selectValue.checked = true;
    selectValue.dispatchEvent(new Event('change'));
  } else {
    console.log('selectValue---- noooo',);
    
    var allValue = document.querySelectorAll(
      '.custom-input-area input[name="option1"]'
    );
    allValue.forEach(function (allValue) {
      var inputAllvalue = allValue.value;
      var parts = inputAllvalue.split("*");
      var valueMultiply = parseInt(parts[0], 10) * parseInt(parts[1], 10);

      console.log('inputMultiply == valueMultiply',inputMultiply ,'=======',valueMultiply )
      if (inputMultiply == valueMultiply) {
        console.log("match");
        document
          .querySelector(
            '.custom-input-area input[name="option1"][value="' +
              inputAllvalue +
              '"]'
          )
          .click();
        document.querySelector(
          '.custom-input-area input[name="option1"][value="' +
            inputAllvalue +
            '"]'
        ).checked = true;
      }
    });
  }
}

// Attach event listeners to increment and decrement buttons
document.querySelectorAll(".increment").forEach(function (button) {
  button.addEventListener("click", function (event) {
    var typeincrement = "";
    var typeincrement = button.classList.contains("input-button-width")
      ? "width"
      : "height";
    updateInputValue(button, true, event, typeincrement, "button");
  });
});

document.querySelectorAll(".decrement").forEach(function (button) {
  button.addEventListener("click", function (event) {
    var typedecrement = "";
    var typedecrement = button.classList.contains("input-button-width")
      ? "width"
      : "height";
    updateInputValue(button, false, event, typedecrement, "button");
  });
});
if(document.getElementById("imageSelectedHight")){
var inputimageSelectedHight = document.getElementById("imageSelectedHight");
inputimageSelectedHight.addEventListener("input", function (event) {
  updateTextWithInputValue("height");
});
}
if( document.getElementById("imageSelectedWidth")){
var inputimageSelectedWidth = document.getElementById("imageSelectedWidth");
inputimageSelectedWidth.addEventListener("input", function (event) {
  updateTextWithInputValue("width");
});
}


// document.querySelectorAll("#customradio-2").forEach(function (button) {
//   button.addEventListener("click", function (event) {
//     document.querySelector(".custom-size").classList.add("disabled");
//     var variantPickers = document.querySelectorAll(
//       ".custom-input-area .variant-picker"
//     );
//     variantPickers.forEach(function (variantPicker) {
//       variantPicker.classList.add("active");
//     });
//   });
// });

document.querySelectorAll('.customradio-outer input[type="radio"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      // document.getElementById("customradio-1").checked = false;
      //   document.querySelector(".custom-size").classList.add("disabled");
        var variantPickers = document.querySelectorAll(
            ".custom-input-area .variant-picker"
        );
        variantPickers.forEach(function (variantPicker) {
            variantPicker.classList.add("active");
        });
    });
});


document.querySelectorAll("#customradio-2").forEach(function (button) {
  button.addEventListener("click", function (event) {
  
    document.querySelector(".custom-size").classList.add("disabled");
    var variantPickers = document.querySelectorAll(
      ".custom-input-area .variant-picker"
    );
    variantPickers.forEach(function (variantPicker) {
      variantPicker.classList.add("active");
    });
  });
});

document.querySelectorAll("#customradio-1").forEach(function (button) {
  button.addEventListener("click", function (event) {
      document.querySelectorAll('.customradio-outer input[type="radio"]').forEach(function(radio) {
    radio.checked = false;
    });
    document.querySelector(".custom-size").classList.remove("disabled");
    var variantPickers = document.querySelectorAll(
      ".custom-input-area .variant-picker"
    );
    variantPickers.forEach(function (variantPicker) {
      variantPicker.classList.remove("active");
    });
  });
});

document.body.addEventListener("click", function (event) {
  if (event.target.classList.contains("upload__img-close")) {
    event.preventDefault();
    document.getElementById("image").value = "";
    document.querySelector(".custom-input-area").classList.add("hidden");
    document
      .querySelector(".product-info__quantity-selector")
      .classList.add("hidden");
    document
      .querySelector(".product-info__buy-buttons")
      .classList.add("hidden");

    var elementsImg = document.getElementsByClassName("image-area");
    var imgElement = document.querySelector(".image-preview img");
    if (imgElement) {
      imgElement.removeAttribute("src");
    }
    var link = document.querySelector(".UploadedImage");
    link.removeAttribute("href");

    elementsImg[0].style.display = "none";
    var elementsUpload = document.getElementsByClassName("upload-container");
    elementsUpload[0].style.display = "block";
  }


  if (event.target.classList.contains("upload__img-close_csv")) {
    event.preventDefault();
  
    // var imgElement = document.querySelector(".image-preview img");
    // if (imgElement) {
    //   imgElement.removeAttribute("src");
    // }

    var imgElement1 = document.querySelector(".imagepreview");
    if (imgElement1) {
      imgElement1.removeAttribute("src");
      document.getElementById('image').value = '';
    }

    document.querySelector(".upload-container").style.display = "block";
    document.querySelector(".image-area").style.display = "none";
  }
});

document.querySelectorAll('input[name="option1"]').forEach(function (option1) {
  option1.addEventListener("click", function (event) {
    setTimeout(function () {
      var getPrice = document.querySelector(".price-list .text-lg").innerText;
      var pricePattern = /\d+\.\d+/;
      var price = getPrice.match(pricePattern)[0];
      document
        .querySelector(".regular.original-price span")
        .setAttribute("data-price", price);
      var symbolpricePattern = /\$\d+\.\d+/;
      var symbolprice = getPrice.match(symbolpricePattern)[0];
      document.querySelector(".regular.original-price span").innerText =
        symbolprice;
      tablePrice();
    }, 200);
  });
});

window.onload = function () {
  tablePrice();
};

function tablePrice() {
  var originalPriceElement = document.querySelector(".original-price");
  var spanWithPriceAttribute = originalPriceElement.querySelector("span");
  var originalPrice = spanWithPriceAttribute.getAttribute("data-price");
  console.log(originalPrice + "original Price");

  var discount_35 = 35;
  const discount35 = originalPrice * (15 / 100);
  var discount35Price = originalPrice - discount35;
  document.querySelector(".discount-35").innerHTML =
    "$" + discount35Price.toFixed(2);

  const discount45 = originalPrice * (25 / 100);
  var discount45Price = originalPrice - discount45;
  document.querySelector(".discount-45").innerHTML =
    "$" + discount45Price.toFixed(2);

  const discount55 = originalPrice * (35 / 100);
  var discount55Price = originalPrice - discount55;
  document.querySelector(".discount-55").innerHTML =
    "$" + discount55Price.toFixed(2);

  const discount65 = originalPrice * (45 / 100);
  var discount65Price = originalPrice - discount65;
  document.querySelector(".discount-65").innerHTML =
    "$" + discount65Price.toFixed(2);

  const discount75 = originalPrice * (55 / 100);
  var discount75Price = originalPrice - discount75;
  document.querySelector(".discount-75").innerHTML =
    "$" + discount75Price.toFixed(2);
}

document.addEventListener("DOMContentLoaded", function () {
  var textarea = document.querySelector(".additional-note");
  if (textarea) {
    textarea.addEventListener("keyup", handleKeyup);
    textarea.addEventListener("keydown", handleKeyup);
  }
  function handleKeyup(event) {
    var textareaValue = event.target.value;
    document.querySelector(".additionalnote").value = textareaValue;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var textarea = document.querySelector(".additional-garment");
  if (textarea) {
    textarea.addEventListener("keyup", handleKeyup);
    textarea.addEventListener("keydown", handleKeyup);
  }
  function handleKeyup(event) {
    var textareaValue = event.target.value;
    document.querySelector(".additionalgarment").value = textareaValue;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var textarea = document.querySelector(".additional-colors");
  if (textarea) {
    textarea.addEventListener("keyup", handleKeyup);
    textarea.addEventListener("keydown", handleKeyup);
  }
  function handleKeyup(event) {
    var textareaValue = event.target.value;
    document.querySelector(".additionalcolors").value = textareaValue;
  }
/* Bulk order box */
  if(document.querySelector('.bulk_order')){
  document.querySelector('.bulk_order').addEventListener('click', function() {
    var bulkOrderBox = document.querySelector('.bulk_order_box');
    var OneOrderBox = document.querySelector('.sigle_variant_inner');
    var input_order = document.querySelector('.input_order');
    var bulk_order = document.querySelector('.bulk_order');
    if (bulkOrderBox.style.display === 'none' || bulkOrderBox.style.display === '') {
      bulkOrderBox.style.display = 'block';
      input_order.style.display = 'inline-flex';
      bulk_order.style.display = 'none';
      OneOrderBox.style.display = 'none';
      document.querySelector('#quantity1').min = 0;
      document.querySelector('#quantity1').value = 0;
      document.querySelector('#quantity0').min = 1;
      document.querySelector('#quantity1').removeAttribute('name');
      document.querySelector('#quantity0').setAttribute('name','properties[Bulk Order]');
      // document.querySelector('#yourText1').value ="";
    }
  });

 document.querySelector('.input_order').addEventListener('click', function() {
  var bulkOrderBox = document.querySelector('.bulk_order_box');
  var OneOrderBox = document.querySelector('.sigle_variant_inner');
  var input_order = document.querySelector('.input_order');
  var bulk_order = document.querySelector('.bulk_order');
  if (bulkOrderBox.style.display === 'block' || bulkOrderBox.style.display === '')  {
    bulkOrderBox.style.display = 'none';
    OneOrderBox.style.display = 'block';
    bulk_order.style.display = 'inline-block';
    input_order.style.display = 'none';
    document.querySelector('#quantity1').min = 1;
    document.querySelector('#quantity0').min = 0;
    document.querySelector('#quantity0').value = 0;
    document.querySelector('#quantity1').setAttribute('name','properties[Quantity1]');
    document.querySelector('#quantity0').removeAttribute('name');
  }
  });
}
//Custom Color js
if( document.querySelector('.custom_color')){

 document.querySelector('.custom_color').addEventListener('click', function() {
  var customOrderBox = document.querySelector('.custom_color-picker');
  var defaultOrderBox = document.querySelector('.default_color-picker');
  var default_order = document.querySelector('.default_color');
  var custom_order = document.querySelector('.custom_color');
  document.querySelector(`#custom_one`).value = `rgb(120 40 80)`;
   
  if (customOrderBox.style.display === 'none' || customOrderBox.style.display === '') {
    customOrderBox.style.display = 'inline-flex';
    defaultOrderBox.style.display = 'none';
    default_order.style.display = 'inline-flex';
    custom_order.style.display = 'none';
    document.querySelector('.first_radio').removeAttribute('checked');
  }
});

   document.querySelector('.default_color').addEventListener('click', function() {
  var customOrderBox = document.querySelector('.custom_color-picker');
  var defaultOrderBox = document.querySelector('.default_color-picker');
  var default_order = document.querySelector('.default_color');
  var custom_order = document.querySelector('.custom_color');
  document.querySelector(`#custom_one`).value = ``;
     
  if (customOrderBox.style.display === 'inline-flex' || customOrderBox.style.display === '') {
    customOrderBox.style.display = 'none';
    defaultOrderBox.style.display = 'inline-flex';
    default_order.style.display = 'none';
    custom_order.style.display = 'inline-flex';
    document.querySelector('.first_radio').setAttribute('checked', 'true');
    
  }
});

const redInput = document.getElementById('red');
const greenInput = document.getElementById('green');
const blueInput = document.getElementById('blue');
const colorDisplay = document.getElementById('color-display');

  const pickr = Pickr.create({
  el: '#color-display',
  theme: 'classic', // or 'monolith', 'nano'
  
  swatches: [
      'rgba(244, 67, 54, 1)',
      'rgba(233, 30, 99, 1)',
      'rgba(156, 39, 176, 1)',
      'rgba(103, 58, 183, 1)',
      'rgba(63, 81, 181, 1)',
      'rgba(33, 150, 243, 1)',
      'rgba(3, 169, 244, 1)',
      'rgba(0, 188, 212, 1)',
      'rgba(0, 150, 136, 1)',
      'rgba(76, 175, 80, 1)',
      'rgba(139, 195, 74, 1)',
      'rgba(205, 220, 57, 1)',
      'rgba(255, 235, 59, 1)',
      'rgba(255, 193, 7, 1)'
  ],
  
  components: {
      preview: true,opacity: true,hue: true,
      interaction: {hex: true,rgba: true,hsla: true,hsva: true,cmyk: true,input: true,clear: true,save: true}
  }
  });
  pickr.on('change', (color, instance) => {
    const rgba = color.toRGBA();
    redInput.value =  rgba[0];
    greenInput.value = rgba[1];
    blueInput.value = rgba[2];
    const button = document.querySelector('.pcr-button');
   const rgbaString = `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
    button.style.setProperty('--pcr-color', rgbaString);

     const targetDiv = document.querySelector(`.custom_product_font_number`);
  
  if (targetDiv) {
     targetDiv.style.color =  `rgb(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
  }
});

// function updateColor() {
//     const r = redInput.value;
//     const g = greenInput.value;
//     const b = blueInput.value;
//     colorDisplay.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
//   const targetDiv = document.querySelector(`.custom_product_font_number`);
  
//   if (targetDiv) {
//    targetDiv.style.color =  `rgb(${r}, ${g}, ${b})`;
//   document.querySelector(`#custom_one`).value = `rgb(${r}, ${g}, ${b})`;
//   }
// }

// redInput.addEventListener('input', updateColor);
// greenInput.addEventListener('input', updateColor);
// blueInput.addEventListener('input', updateColor);
}
/* Outline text */
if( document.querySelector('.custom_color_o')){
  document.querySelector('.custom_color_o').addEventListener('click', function() {
  var customOrderBox = document.querySelector('.custom_color-picker_o');
  var defaultOrderBox = document.querySelector('.default_color-picker_o');
  var default_order = document.querySelector('.default_color_o');
  var custom_order = document.querySelector('.custom_color_o');
  if (customOrderBox.style.display === 'none' || customOrderBox.style.display === '') {
    customOrderBox.style.display = 'inline-flex';
    defaultOrderBox.style.display = 'none';
    default_order.style.display = 'inline-flex';
    custom_order.style.display = 'none';
      document.querySelector(`#custom_second`).value = `rgb(120 40 80)`;
  }
});

   document.querySelector('.default_color_o').addEventListener('click', function() {
  var customOrderBox = document.querySelector('.custom_color-picker_o');
  var defaultOrderBox = document.querySelector('.default_color-picker_o');
  var default_order = document.querySelector('.default_color_o');
  var custom_order = document.querySelector('.custom_color_o');
  if (customOrderBox.style.display === 'inline-flex' || customOrderBox.style.display === '') {
    customOrderBox.style.display = 'none';
    defaultOrderBox.style.display = 'inline-flex';
    default_order.style.display = 'none';
    custom_order.style.display = 'inline-flex';
  document.querySelector(`#custom_second`).value = ``;
    
  }
});
const redInput_o = document.getElementById('red_o');
const greenInput_o = document.getElementById('green_o');
const blueInput_o = document.getElementById('blue_o');
const colorDisplay_o = document.getElementById('color-display_o');

  const pickr = Pickr.create({
  el: '#color-display_o',
  theme: 'classic', // or 'monolith', 'nano'
  
  swatches: [
      'rgba(244, 67, 54, 1)',
      'rgba(233, 30, 99, 1)',
      'rgba(156, 39, 176, 1)',
      'rgba(103, 58, 183, 1)',
      'rgba(63, 81, 181, 1)',
      'rgba(33, 150, 243, 1)',
      'rgba(3, 169, 244, 1)',
      'rgba(0, 188, 212, 1)',
      'rgba(0, 150, 136, 1)',
      'rgba(76, 175, 80, 1)',
      'rgba(139, 195, 74, 1)',
      'rgba(205, 220, 57, 1)',
      'rgba(255, 235, 59, 1)',
      'rgba(255, 193, 7, 1)'
  ],
  
  components: {
      preview: true,opacity: true,hue: true,
      interaction: {hex: true,rgba: true,hsla: true,hsva: true,cmyk: true,input: true,clear: true,save: true}
  }
  });
  pickr.on('change', (color, instance) => {
    const rgba = color.toRGBA();
    redInput_o.value =  rgba[0];
    greenInput_o.value = rgba[1];
    blueInput_o.value = rgba[2];
    const button = document.querySelector('.pcr-button');
   const rgbaString = `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
    button.style.setProperty('--pcr-color', rgbaString);

     const targetDiv = document.querySelector(`.custom_product_font_number`);
  
  if (targetDiv) {
     targetDiv.style.webkitTextStrokeColor =  `rgb(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
      document.querySelector(`#custom_second`).value = `rgb(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
  }
});
 

 
}


  /* Custom size */
  const input = document.getElementById('custom-size');
  const errorMessage = document.getElementById('error-message');
  const radioButtons = document.querySelectorAll('.size input');

  input.addEventListener('input', function() {
  const value = parseFloat(this.value);
  const value1 = this;
  const min = 0.5;
  const max = 8;


    console.log('value', value, isNaN(value) )
  if (value < min || value > max ) {
    this.classList.add('invalid');
    errorMessage.style.display = 'block';
  } else {
    this.classList.remove('invalid');
    errorMessage.style.display = 'none';
      selectClosestRadioButton(value1);
  }
  });
  function selectClosestRadioButton(varthis) {
   var inputValue = parseFloat(varthis.value);

                if (isNaN(inputValue)) return;

                // Collect all radio button values
                var radioButtons = document.querySelectorAll('.size .custom_get_family  input');
                var radioValues = Array.from(radioButtons).map(function(radio) {
                    return parseFloat(radio.value);
                });


    console.log('radioValues', radioValues)
                // Find the nearest value
                var nearestValue = radioValues.reduce(function(prev, curr) {
                    return (Math.abs(curr - inputValue) < Math.abs(prev - inputValue) ? curr : prev);
                });

    console.log('nearestValue', nearestValue)
    
                // Check the nearest radio button
                radioButtons.forEach(function(radio) {
                    if (parseFloat(radio.value) === nearestValue) {
                         radio.click();
                        radio.checked = true;
                    } else {
                        radio.checked = false;
                    }
                });
  }

});

